import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { textStyle } from 'theme/names';
import { QA } from '../qa';
import { BiSolidNotepad } from 'react-icons/bi';
import { SiAnswer } from 'react-icons/si';
import { useDebouncedCallback } from 'use-debounce';
import { updateUser } from 'utils/sessionHelper';
import { useRouter } from 'next/router';

interface QAsProps {
  targetAudience: string;
  jobTitle: string;
  writingStyle: string;
  industry: string;
  company: string;
  about: string;
}
interface QAModalProps {
  isQAModalOpen: boolean;
  onCloseQAModal: (() => Promise<void>);
  currentTalGPTQAs: QAsProps;
  setTalGPTQAs: Dispatch<SetStateAction<any>> | ((value: any) => void);
  session: any | object;
  finalRef: React.RefObject<any>;
}

export const TalQAModal = ({ isQAModalOpen, onCloseQAModal, setTalGPTQAs, currentTalGPTQAs, session, finalRef }: QAModalProps) => {
  const router = useRouter();
  //talGPT save QA Loading
  const [saveQALoading, setSaveQALoading] = useState(false);
  //talGPT is any textarea Empty
  const [isTalQAsEmpty, setIsTalQAsEmpty] = useState(true);

  const [isValidating, setIsValidating] = useState(true);

  //talGPT char lens for QAs

  const [talQACharError, setTalQACharError] = useState({
    charLengthFor: [] as any,
    charLenNotOkay: false,
  });

  //refs for talGPT -- needs a bit of refactor
  const highlightQARef = useRef<any>(new Map());
  const qaRefs = useRef<any>(new Map());

  const handleTalQAs = async (answerValue: any, questionIdentifier: string, elem: any) => {
    //used to update the answers to six questions
    const answers = currentTalGPTQAs;
    answers[questionIdentifier] = answerValue;
    setTalGPTQAs(answers);
  };

  const checkTalQAEmpty = async () => {
    //check state of each property of object and make sure that all objects QAs are filled, before allowing the user to close the dropdown
    console.log('validating inputs...');
    setIsValidating(true);
    let isAnyEmpty = false;
    let checkCharLengths = {
      charLengthFor: [] as any,
      charLenNotOkay: false,
    };

    Object.entries(currentTalGPTQAs).map((val, i) => {
      if (Boolean(val[1]) === false) isAnyEmpty = true;
      //uncomment this when re-introducing char lenghts check
      // if (!isAnyEmpty && val[1]?.length < 30) {
      //   checkCharLengths.charLenNotOkay = true;
      //   checkCharLengths.charLengthFor.push(val[0]);
      // }
    });

    setIsTalQAsEmpty(isAnyEmpty);
    setTalQACharError({ ...checkCharLengths });
    setIsValidating(false);
  };

  const onSaveTalQAs = async () => {
    setSaveQALoading(true);
    try {
      //needs a refactor at some point. 
      if (isTalQAsEmpty) {
        throw new Error('Please answer all the questions to generate posts');
      }

      if (!isTalQAsEmpty && talQACharError.charLenNotOkay && talQACharError.charLengthFor.length > 0) {

        // console.log(highlightQARef.current, currentTalGPTQAs, talQACharError, 'check ref')
        talQACharError.charLengthFor.forEach((elem) => {
          if (!highlightQARef.current.has(elem)) highlightQARef.current.set(elem, qaRefs.current.get(elem));
        });

      }

      highlightQARef.current.forEach((value, key) => {
        if (!talQACharError.charLengthFor.includes(key)) highlightQARef.current.delete(key);
      });

      //uncomment to re-enable validation for inputs
      // qaRefs.current.forEach((value, key) => {
      //   if (highlightQARef.current.has(key)) {
      //     value.current.style.border = "2px solid red";
      //   } else {
      //     value.current.style.border = "none";
      //   }
      // });

      // if (talQACharError?.charLenNotOkay) throw new Error('Please input more data for the highlighted question below:');

      //save qas to db. send callback to post generator page. load post generator page.
      await updateUser(session, {
        postGenQA: { ...currentTalGPTQAs },
      });

      toast.success('Saved settings successfully');

      onCloseQAModal();

    } catch (e) {
      toast.error(e?.message);
      console.log('Error in Saving QAs: ', e);
    } finally {
      setSaveQALoading(false);
      return;
    }
  };

  const handleBackButton = async () => {
    // await checkTalQAEmpty();
    // console.log(talQACharError.charLenNotOkay, isTalQAsEmpty);
    if (talQACharError.charLenNotOkay || isTalQAsEmpty) {
      router.push('/auto');
    } else {
      onCloseQAModal();
    }
  }

  useEffect(() => {
    const init = async () => {
      await checkTalQAEmpty();
    }
    init();
  }, []);

  const assignQARefs = (inputName) => {
    if (!qaRefs.current.has(inputName)) qaRefs.current.set(inputName, React.createRef());
    return qaRefs.current.get(inputName);
  };

  const debouncedOnSaveTalQAs = useDebouncedCallback(onSaveTalQAs, 1500);

  return (
    <Modal
      isOpen={isQAModalOpen}
      onClose={onCloseQAModal}
      closeOnOverlayClick={false}
      blockScrollOnMount={true}
      closeOnEsc={false}
      isCentered={true}
      scrollBehavior="inside"
      size={"6xl"}
      finalFocusRef={finalRef}
    >
      <ModalOverlay bg='blackAlpha.300'
        backdropFilter='blur(10px)' />
      <ModalContent>
        <ModalHeader>
          <Flex flexDir={"row"} gap={3}>

            <SiAnswer />
            <Text
              fontSize={"2xl"}
              fontWeight={"bold"}
              textStyle={textStyle["body.medium.standard"]}
            >
              Post Generator Questions:
            </Text>


          </Flex>
        </ModalHeader>
        <ModalBody pb={6}>
          <Box>
            <Flex gap="2" mb={6} alignItems="start">
              <AiOutlineInfoCircle size="20" color="#0A66C2" />
              <Text
                fontSize="md"
                textStyle={textStyle["body.medium.standard"]}
              >
                Please answer the questions below to generate posts. Without answering these six question, we will not be able to generate the post(s).
              </Text>
            </Flex>

            <QA
              questionString="Who are your target audience?"
              placeHolder="Example: Mid-level marketing professionals looking to enhance their skills and knowledge in digital marketing."
              inputType="textarea"
              inputProps={{ isRequired: true, isDisabled: saveQALoading, defaultValue: currentTalGPTQAs?.targetAudience }}
              containerProps={{ mb: 4 }}
              infoBelowInput="Example Input: Sales people doing prospection."
              inputIndentifier="targetAudience"
              onInputChangeCallBack={handleTalQAs}
              containerRef={assignQARefs("targetAudience")}

            />

            <QA
              questionString="What's your job title?"
              placeHolder="Example: Head of Digital Marketing."
              inputType="textarea"
              inputProps={{ isRequired: true, isDisabled: saveQALoading, defaultValue: currentTalGPTQAs?.jobTitle }}
              containerProps={{ mb: 4 }}
              infoBelowInput="Example Input: Sales Leader"
              inputIndentifier="jobTitle"
              onInputChangeCallBack={handleTalQAs}
              containerRef={assignQARefs("jobTitle")}
            />

            <QA
              questionString="What's your writing style?"
              placeHolder="Example: Conversational, engaging, and informative with a touch of humor."
              inputType="textarea"
              inputProps={{ isRequired: true, isDisabled: saveQALoading, defaultValue: currentTalGPTQAs?.writingStyle }}
              containerProps={{ mb: 4 }}
              infoBelowInput="Example Input: Authoritative and witty, and conversational"
              inputIndentifier="writingStyle"
              onInputChangeCallBack={handleTalQAs}
              containerRef={assignQARefs("writingStyle")}
            />

            <QA
              questionString="What industry do you work in?"
              placeHolder="Example: Digital Marketing and Advertising."
              inputType="textarea"
              inputProps={{ isRequired: true, isDisabled: saveQALoading, defaultValue: currentTalGPTQAs?.industry }}
              containerProps={{ mb: 4 }}
              infoBelowInput="Example Input: SaaS technology"
              inputIndentifier="industry"
              onInputChangeCallBack={handleTalQAs}
              containerRef={assignQARefs("industry")}
            />

            <QA
              questionString="Tell us a little bit about your company - what do you do?"
              placeHolder="Example: At BrightWave Digital, we specialize in creating comprehensive digital marketing strategies for small to medium-sized businesses. Our services include social media management, search engine optimization (SEO), content marketing..."
              inputType="textarea"
              inputProps={{ isRequired: true, isDisabled: saveQALoading, defaultValue: currentTalGPTQAs?.company }}
              containerProps={{ mb: 4 }}
              infoBelowInput="Example Input: lemlist is an all-in-one sales engagement + cold outreach tool. lemlist allows you to Book 10+ Meetings Every Week. You can find buyer-ready prospects with a lead database and intent data, get valid email addresses with a deliverability score and generate highly personalized multichannel campaigns across linkedin and email!"
              inputIndentifier="company"
              onInputChangeCallBack={handleTalQAs}
              containerRef={assignQARefs("company")}
            />

            <QA
              questionString="Tell us a little bit about yourself!"
              placeHolder="Example: With over a decade of experience in digital marketing, I have a deep passion for helping businesses thrive in the online world. My journey began as a content writer, where I developed a knack for crafting compelling stories..."
              inputType="textarea"
              inputProps={{ isRequired: true, isDisabled: saveQALoading, defaultValue: currentTalGPTQAs?.about }}
              containerProps={{ mb: 4 }}
              infoBelowInput="Example Input: I am the sales leader at a tech company called lemlist. I started my career as a BDR and worked my way up. I’m a huge fan of football, fruit and music! I currently make youtube videos too about sales tips. I usually post helpful sales prospection tips to grow your business and book 10+ meetings every week."
              inputIndentifier="about"
              onInputChangeCallBack={handleTalQAs}
              containerRef={assignQARefs("about")}
            />

          </Box>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            onClick={async () => {
              setSaveQALoading(true);
              await checkTalQAEmpty();
              debouncedOnSaveTalQAs();
            }}
            // isDisabled={textAreaValue.length === 0}
            leftIcon={<BiSolidNotepad />}
            size={"lg"}
            mt={2}
            fontSize={"md"}
            isLoading={saveQALoading}
          >
            Save Answers
          </Button>
          <Button
            type="button"
            variant={"secondary"}
            onClick={async (e) => {
              await checkTalQAEmpty();
              await handleBackButton();
            }}
            isDisabled={isValidating}
          >
            Back
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}